//http://nhsggc.local/umbraco/surface/NHSJobsImport/getJobsJSON


$(function () {

    // results show / hide
    $('#results').on('click', '.job-entry__heading', function (e) {

        //console.log('Here');

        e.preventDefault();
        var $me = $(this);
        var $details = $me.parent();

        if ($details.hasClass('job-entry--small')) {
            $details.removeClass('job-entry--small');
        } else {
            $details.addClass('job-entry--small');
        }
    });

    $('.clearField').click(function (e) {
        e.preventDefault();
        var target = $(this).attr('data-field');
        console.log(target);
        $('#' + target).val('');
    }); 

    // sp will be populated by the search macro
    if (typeof sp !== "undefined") {
        // Set all the default
        //console.log('setting up the search filter defaults');

        $('#textSearch').val(sp.textSearch);
        $('#location').val(sp.location);
        $('#fullPartTime').val(sp.fullPartTime);
        $('#contract').val(sp.contract);
        $('#payGrade').val(sp.payGrade);
        $('#orderBy').val(sp.orderBy);
        $('#category').val(sp.category);

        if (sp.lockedCat) {
            // Lock category down
            console.log('Locking category');
            $('#category option:not(:selected)').attr('disabled', true);
        }

    }

    // Loaded jobs script
    getResults(true);



});


function scrollToAnchor(aid) {
    var aTag = $(aid);
    $('html,body').animate({ scrollTop: aTag.offset().top }, 'fast');
}


function getResults(isPageLoad) {

    var $results = $('#results');
    $results.html("Loading results...");

    // This can do a search in place or a post to the generic search. 
    // If the search results macro is embedded, search in place using ajax
    // If the search results macro is NOT embedded, post the form to the generic results page
    var isDynamicSearch = $results.length > 0 ? true : false;
    console.log('isDynamicSearch : %o', isDynamicSearch);

    if (isDynamicSearch) {

        // Search in place
        var sp = {
            textSearch: $.trim($('#textSearch').val()),
            location: $.trim($('#location').val()),
            fullPartTime: $.trim($('#fullPartTime').val()),
            contract: $.trim($('#contract').val()),
            payGrade: $.trim($('#payGrade').val()),
            orderBy: $('#orderBy').val(),
            category: $('#category').val()
        };

        $.ajax({
            method: "POST",
            url: "/umbraco/surface/NHSJobsImport/getJobsJSON",
            data: sp
        }).done(function (res) {

            console.log("Result data : %o - Page load : %o", res, isPageLoad);
            $('#resultCount').val(res.total);
            if (res.total === 0) {
                $('#results').html("<p><b>Sorry, no results found</b></p>");
                console.log(res.query);
            } else {
                var source = document.getElementById("jobEntry").innerHTML;
                var template = Handlebars.compile(source);
                var html = template(res.hits);
                $('#results').html(html);

                if (!isPageLoad) {
                    console.log('scrollToAnchor');
                    scrollToAnchor('#results');
                }
            }

            });

    } else {

        if (!isPageLoad) {
            console.log('Submit form');
            // Post to the search page
            $('#jobsFilter').submit();
        }

    }
     
}


Handlebars.registerHelper("formatDate", function (datetime) {

    //var workingDate = eval(datetime);
    var workingDate = new Date(parseInt(datetime.substr(6)));

    if (moment) {
        return moment(workingDate).format('DD/MM/YYYY');
    } else {
        return datetime;
    }
});
Handlebars.registerHelper("sanitiseString", function (messy, newLength) {
    if (messy !== undefined && messy !== null && messy !== '') {
        var camelCaseStr = camelCase(messy);
        if (camelCaseStr.length > newLength) {
            return camelCaseStr.substring(0, newLength);
        }
        return camelCaseStr;
    } else {
        return '';
    }
});


function camelCase(str) {
    str = replaceAccents(str);
    str = removeNonWord(str)
        .replace(/\-/g, ' ') //convert all hyphens to spaces
        .replace(/\s[a-z]/g, upperCase) //convert first char of each word to UPPERCASE
        .replace(/\s+/g, '') //remove spaces
        .replace(/^[A-Z]/g, lowerCase); //convert first char to lowercase
    return str;
}
function removeNonWord(str) {
    return str.replace(/[^0-9a-zA-Z\xC0-\xFF \-]/g, '');
}
function replaceAccents(str) {
    // verifies if the String has accents and replace them
    if (str.search(/[\xC0-\xFF]/g) > -1) {
        str = str
            .replace(/[\xC0-\xC5]/g, "A")
            .replace(/[\xC6]/g, "AE")
            .replace(/[\xC7]/g, "C")
            .replace(/[\xC8-\xCB]/g, "E")
            .replace(/[\xCC-\xCF]/g, "I")
            .replace(/[\xD0]/g, "D")
            .replace(/[\xD1]/g, "N")
            .replace(/[\xD2-\xD6\xD8]/g, "O")
            .replace(/[\xD9-\xDC]/g, "U")
            .replace(/[\xDD]/g, "Y")
            .replace(/[\xDE]/g, "P")
            .replace(/[\xE0-\xE5]/g, "a")
            .replace(/[\xE6]/g, "ae")
            .replace(/[\xE7]/g, "c")
            .replace(/[\xE8-\xEB]/g, "e")
            .replace(/[\xEC-\xEF]/g, "i")
            .replace(/[\xF1]/g, "n")
            .replace(/[\xF2-\xF6\xF8]/g, "o")
            .replace(/[\xF9-\xFC]/g, "u")
            .replace(/[\xFE]/g, "p")
            .replace(/[\xFD\xFF]/g, "y");
    }

    return str;
}

function upperCase(str) {
    return str.toUpperCase();
}
function lowerCase(str) {
    return str.toLowerCase();
}